import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { PermissoesTabsetComponent } from '../permissoes-tabset/permissoes-tabset.component';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-usuario-grupo-acesso',
  templateUrl: './listar-usuario-grupo-acesso.component.html',
  styleUrls: ['./listar-usuario-grupo-acesso.component.css']
})
export class ListarUsuarioGrupoAcessoComponent implements OnInit {

  usuarios: Usuario[];

  filtroPesquisaNomeUsuarioBind: string;

  paginacao: Paginacao;

  evento: Evento;

  selecionados: boolean;

  public loading = false;

  constructor(private _usuarioService: UsuarioService,
    private _comumService: ComumService,
    private _permissoesTabset: PermissoesTabsetComponent,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.usuarios = new Array<Usuario>();

    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    this._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe((usuarios: Usuario[]) => {
        this.usuarios = usuarios;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeUsuarioBind = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  voltar(): void {
    this._permissoesTabset.voltar();
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/listar-usuario-grupo-acesso/listar-usuario-grupo-acesso.component.ts